// extracted by mini-css-extract-plugin
module.exports = {"slide":"HomepageSlide_slide__2ziZj","image":"HomepageSlide_image__2Q3Ey","quote":"HomepageSlide_quote__1SZ1H","rightContainer":"HomepageSlide_rightContainer__3_AQa"};